/* eslint-disable no-lonely-if */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import $ from 'jquery';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import _t from './translate';
import checkMetamask from './checkMetamask';
import login from './checkLogin';
import {
  getToken,
} from './login.js';

const createTeam = async () => {
  const teamElements = $('.createTeam');
  if (!teamElements.length) {
    return;
  }

  teamElements.off('click.createTeam').on('click.createTeam', async (e) => {
    e.preventDefault();

    const token = getToken();

    // await checkMetamask();

    // if (!await login()) {
    //   return;
    // }

    Swal.fire({
      title: _t('Hi Manager !'),
      html: `
        <br>
        <br>
          Create your team
          `,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off',
      },
      customClass: {
        popup: 'sw-long',
        cancelButton: 'order-1',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
      inputValidator(inputValue) {
        if (!inputValue) {
          return 'Please enter your team name';
        }
      },
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: _t('Save'),
      showLoaderOnConfirm: true,
      preConfirm: async (value) => {
        // const accounts = await web3Client.eth.getAccounts();
        // const address = accounts[0];
        const name = value;
        const msgData = {
          name,
          // address,
          // sessionKey: window.sessionKey,
          token,
        };

        $.post({
          url: '/api/team/createTeam',
          headers: {
            token: window.token,
          },
          data: msgData,
          success: async (data) => {
            if (data.success) {
              await Swal.fire(
                _t('Success!'),
                _t('Team Created !'),
                'success',
              );

              document.location.reload(true);
            } else {
              Swal.fire(
                _t('Error!'),
                data.message,
                'error',
              );
            }
          },
          error(xhr, status, error) {
            // handle error
          },
        });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  });
};

export default createTeam;
